import type { ChangelogEntry } from "../types";

/**
 * VIB-2723. Ny skriveflate i dokumentarkivet. Gatet på
 * `feature_dokumentarkiv` som resten av arkivet, så ingen får beskjed før
 * arkivet er rullet ut til rollen deres.
 *
 * Skrivepunktet har ikke rollekrav: hvem som kan skrive styres per mappe, ikke
 * av systemrollen. Punktet om formatering gjelder alle som har skrivetilgang
 * et sted.
 */
export const DOKUMENTEDITOR_2026_10: ChangelogEntry = {
  id: "2026-10-02-dokumenteditor",
  date: "2026-10-02",
  title: "Ny skriveflate for dokumenter",
  summary:
    "Dokumenter du skriver i systemet har fått en roligere editor: du formaterer ved å markere tekst, i stedet for å lete i en knapperad.",
  sections: [
    {
      heading: "Dokumenter",
      items: [
        {
          title: "Marker tekst for å formatere",
          kind: "forbedret",
          body: "Verktøylinja dukker opp der markøren er, i stedet for å ligge som en fast rad på toppen. Du får overskrifter, punktliste, nummerert liste, fet, kursiv og lenke. Trykker du H2 på en linje som allerede er en overskrift, blir den vanlig tekst igjen.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Enter og Shift+Enter gjør to forskjellige ting",
          kind: "forbedret",
          body: "Enter starter et nytt avsnitt. Shift+Enter gir et linjeskift i avsnittet du står i, som når du vil ha en adresse på flere linjer uten luft mellom.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Innlimt tekst tar ikke med seg formatering fra andre steder",
          kind: "forbedret",
          body: "Limer du inn fra Word eller en nettside, kommer teksten inn ren. Det er med vilje: et dokument i arkivet skal se ut som resten av arkivet, ikke som stedet det kom fra.",
          featureFlag: "feature_dokumentarkiv",
        },
      ],
    },
  ],
};
